import { auth } from '@/firebase';
import * as firebase from 'firebase/app';
import router from './../../router';
import availableCountries from '@/assets/data/available-countries';
import {
  SET_COUNTRY,
  SET_ACCOUNT_TYPE,
  SET_SUBSCRIPTION_TYPE,
  SET_USER
} from './../mutation-types';

export default {
  namespaced: true,
  state: {
    country: false,
    accountType: false,
    subscriptionType: null,
    user: null
  },
  mutations: {
    [SET_COUNTRY](state, value) {
      state.country = value;
    },
    [SET_ACCOUNT_TYPE](state, value) {
      state.accountType = value;
    },
    [SET_SUBSCRIPTION_TYPE](state, value) {
      state.subscriptionType = value;
    },
    [SET_USER](state, payload) {
      state.user = payload;
    }
  },
  actions: {
    setAccountType({ commit }, value) {
      commit(SET_ACCOUNT_TYPE, value);
    },
    setSubscriptionType({ commit }, value) {
      commit(SET_SUBSCRIPTION_TYPE, value);
    },
    setCountry({ commit }, value) {
      commit(SET_COUNTRY, value);
    },
    async signUserUp(context, payload) {
      const { email, password, displayName } = payload;
      try {
        let userData = await auth.createUserWithEmailAndPassword(
          email,
          password
        );
        await userData.user.updateProfile({
          displayName: displayName
        });
        await userData.user.sendEmailVerification();
        router.push({ path: '/email-verify' });
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async signUserIn({ dispatch }, payload) {
      const { email, password } = payload;
      let userData = await auth.signInWithEmailAndPassword(email, password);
      if (userData.user.emailVerified) {
        dispatch('autoSignIn', userData.user);
        const path = router.currentRoute.query.redirect || '/';
        router.push({ path: path });
      } else {
        //await userData.user.sendEmailVerification();
        router.push({ path: '/email-verify' });
      }
    },
    async signUserInGoogle({ dispatch }) {
      const provider = new firebase.auth.GoogleAuthProvider();
      let user = await auth.signInWithPopup(provider);
      dispatch('autoSignIn', user);
      const path = router.currentRoute.query.redirect || '/';
      router.push({ path: path });
    },
    async signUserInMicrosoft({ dispatch }) {
      const provider = new firebase.auth.OAuthProvider('microsoft.com');
      let user = await auth.signInWithPopup(provider);
      dispatch('autoSignIn', user);
      const path = router.currentRoute.query.redirect || '/';
      router.push({ path: path });
    },
    async signUserInFacebook({ dispatch }) {
      const provider = new firebase.auth.FacebookAuthProvider();
      let user = await auth.signInWithPopup(provider);
      dispatch('autoSignIn', user);
      const path = router.currentRoute.query.redirect || '/';
      router.push({ path: path });
    },
    async signUserInGithub({ dispatch }) {
      const provider = new firebase.auth.GithubAuthProvider();
      let user = await auth.signInWithPopup(provider);
      dispatch('autoSignIn', user);
      const path = router.currentRoute.query.redirect || '/';
      router.push({ path: path });
    },
    async signUserInTwitter({ dispatch }) {
      const provider = new firebase.auth.TwitterAuthProvider();
      let user = await auth.signInWithPopup(provider);
      dispatch('autoSignIn', user);
      const path = router.currentRoute.query.redirect || '/';
      router.push({ path: path });
    },
    async resetPasswordWithEmail(context, payload) {
      const { email } = payload;
      try {
        await auth.sendPasswordResetEmail(email);
        console.log('Email Sent');
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async checkMailVerified() {
      await auth.currentUser.reload();
      console.log(auth.currentUser.emailVerified);
      if (auth.currentUser.emailVerified) {
        const path = router.currentRoute.query.redirect || '/';
        router.push({ path: path });
      } else throw 'Verify your email';
    },
    async resendMailVerified() {
      await auth.currentUser.sendEmailVerification();
    },
    autoSignIn({ commit }, payload) {
      const { uid, displayName, email, photoURL } = payload;
      commit(SET_USER, {
        uid,
        displayName,
        email,
        photoURL
      });
    },
    async signOut({ commit }) {
      console.log('logout');
      try {
        auth.signOut();
        commit(SET_USER, null);
        window.location.reload();
        console.log('LogOut Sucefully');
      } catch (error) {
        console.log(error);
      }
    }
  },
  getters: {
    accountType(state) {
      return state.accountType;
    },
    country(state) {
      return state.country;
    },
    user(state) {
      return state.user;
    },
    getCountryParams(state) {
      //return state.country;
      if (state.country) {
        return availableCountries.find(
          country => country.country_code === state.country
        );
      } else return null;
    }
  }
};
